import { useContext } from 'react';
import { SupabaseConnectionContext } from '@/lib/supabase-connection-types';

export const useSupabaseConnection = () => {
  const context = useContext(SupabaseConnectionContext);
  if (!context) {
    throw new Error('useSupabaseConnection must be used within SupabaseConnectionProvider');
  }
  return context;
};